export const events = [
  {
    id: 1,
    title: "Quarterly Day of Prayer",
    date: "Saturday, January 3, 2026",
    location: "Online Event",
    category: "Global",
    organizer: "General Conference",
    description: "Join believers worldwide in a special day of prayer and spiritual renewal. This quarterly event brings together the global Seventh-day Adventist community for focused intercession and worship.",
    image: "https://public.readdy.ai/ai/img_res/a215d2bd8491eac65414f46c3ef15837.jpg"
  },
  {
    id: 2,
    title: "Ten Days of Prayer",
    date: "January 7-17, 2026",
    location: "Online Event",
    category: "Global",
    organizer: "General Conference",
    description: "Experience ten transformative days of prayer, Bible study, and spiritual growth. This annual event invites church members worldwide to deepen their relationship with God through focused prayer and fellowship.",
    image: "https://readdy.ai/api/search-image?query=people%20studying%20bible%20together%20in%20small%20group%2C%20warm%20indoor%20lighting%2C%20modern%20church%20interior%2C%20diverse%20participants%2C%20peaceful%20atmosphere%2C%20photorealistic%2C%20high%20quality&width=800&height=600&seq=event2&orientation=landscape"
  },
  {
    id: 3,
    title: "Women's Day of Prayer",
    date: "Saturday, March 7, 2026",
    location: "Online Event",
    category: "Global",
    organizer: "General Conference",
    description: "A special day dedicated to women's ministry, featuring inspiring messages, prayer sessions, and fellowship. Women from around the world unite in prayer and worship.",
    image: "https://readdy.ai/api/search-image?query=diverse%20women%20praying%20together%20in%20beautiful%20church%20setting%2C%20warm%20natural%20lighting%2C%20peaceful%20atmosphere%2C%20contemporary%20worship%20space%2C%20photorealistic%2C%20high%20quality%2C%20spiritual%20gathering&width=800&height=600&seq=event3&orientation=landscape"
  },
  {
    id: 4,
    title: "Youth Week of Prayer",
    date: "March 14-21, 2026",
    location: "Online Event",
    category: "Global",
    organizer: "General Conference",
    description: "A week dedicated to youth spiritual growth and empowerment. Young people worldwide gather for inspiring messages, worship, and fellowship.",
    image: "https://readdy.ai/api/search-image?query=young%20people%20worshiping%20together%20in%20modern%20church%2C%20energetic%20atmosphere%2C%20contemporary%20setting%2C%20diverse%20youth%20group%2C%20photorealistic%2C%20high%20quality%2C%20vibrant%20spiritual%20gathering&width=800&height=600&seq=event4&orientation=landscape"
  },
  {
    id: 5,
    title: "West-Central Africa Division Camp Meeting",
    date: "April 10-17, 2026",
    location: "Lagos, Nigeria",
    category: "Regional",
    organizer: "West-Central Africa Division",
    description: "Annual camp meeting bringing together believers from across West-Central Africa for worship, fellowship, and spiritual renewal.",
    image: "https://readdy.ai/api/search-image?query=large%20outdoor%20church%20gathering%20in%20Africa%2C%20tent%20meeting%2C%20diverse%20crowd%20worshiping%2C%20tropical%20setting%2C%20photorealistic%2C%20high%20quality%2C%20spiritual%20celebration&width=800&height=600&seq=event5&orientation=landscape"
  },
  {
    id: 6,
    title: "Global Youth Day",
    date: "Saturday, March 21, 2026",
    location: "Online Event",
    category: "Global",
    organizer: "General Conference",
    description: "A worldwide celebration of youth ministry and service. Young people engage in community service projects and worship activities.",
    image: "https://readdy.ai/api/search-image?query=young%20people%20serving%20community%20together%2C%20volunteer%20work%2C%20diverse%20youth%20group%2C%20modern%20setting%2C%20photorealistic%2C%20high%20quality%2C%20joyful%20service&width=800&height=600&seq=event6&orientation=landscape"
  },
  {
    id: 7,
    title: "Easter",
    date: "Sunday, April 5, 2026",
    location: "Worldwide",
    category: "National Holiday",
    organizer: "Various",
    description: "Celebration of the resurrection of Jesus Christ.",
    image: "https://readdy.ai/api/search-image?query=easter%20sunrise%20service%2C%20cross%20silhouette%2C%20beautiful%20morning%20light%2C%20peaceful%20atmosphere%2C%20photorealistic%2C%20high%20quality&width=800&height=600&seq=event7&orientation=landscape"
  },
  {
    id: 8,
    title: "Nigerian Union Conference Annual Council",
    date: "May 15-18, 2026",
    location: "Abuja, Nigeria",
    category: "Conference",
    organizer: "Nigerian Union Conference",
    description: "Annual administrative meeting for church leaders across Nigeria to discuss ministry plans and organizational matters.",
    image: "https://readdy.ai/api/search-image?query=professional%20church%20conference%20meeting%2C%20modern%20conference%20hall%2C%20diverse%20church%20leaders%2C%20formal%20setting%2C%20photorealistic%2C%20high%20quality&width=800&height=600&seq=event8&orientation=landscape"
  },
  {
    id: 9,
    title: "Pathfinder Camporee",
    date: "June 5-8, 2026",
    location: "Jos, Nigeria",
    category: "Youth",
    organizer: "West-Central Africa Division",
    description: "Regional Pathfinder camping event featuring outdoor activities, spiritual programs, and skill-building workshops for youth.",
    image: "https://readdy.ai/api/search-image?query=youth%20camping%20event%2C%20pathfinder%20uniforms%2C%20outdoor%20activities%2C%20tents%2C%20diverse%20young%20people%2C%20photorealistic%2C%20high%20quality%2C%20adventure%20setting&width=800&height=600&seq=event9&orientation=landscape"
  },
  {
    id: 10,
    title: "Adventist World Radio Day",
    date: "Saturday, June 13, 2026",
    location: "Online Event",
    category: "Global",
    organizer: "General Conference",
    description: "Celebrating the ministry of Adventist World Radio and its impact in sharing the gospel worldwide through broadcasting.",
    image: "https://readdy.ai/api/search-image?query=radio%20broadcasting%20studio%2C%20modern%20equipment%2C%20people%20recording%20podcast%2C%20professional%20setting%2C%20photorealistic%2C%20high%20quality&width=800&height=600&seq=event10&orientation=landscape"
  }
];
